import * as React from "react";
import { FunctionComponent, useCallback, useContext, useEffect } from "react";
import { ILang } from "../i18n/ILang";
import { NavContext } from "../Nav/NavContext";

export const AnalyticsObserver: FunctionComponent<{
  children?: React.ReactNode;
  elRef: React.MutableRefObject<HTMLDivElement>;
  lang: ILang;
}> = ({ children, elRef, lang }) => {
  const [{ onAnalyticsRequestCallback }] = useContext(NavContext);

  const onClickOnTrackedItem = useCallback(
    (e: MouseEvent) => {
      const label = (e.target as HTMLElement).dataset?.trackLabel;

      if (typeof label !== "undefined") {
        onAnalyticsRequestCallback?.(label);
      }
    },
    [onAnalyticsRequestCallback]
  );

  useEffect(() => {
    const el = elRef.current;
    el?.addEventListener("click", onClickOnTrackedItem);

    return () => {
      el?.removeEventListener("click", onClickOnTrackedItem);
    };
  }, [lang, elRef, onClickOnTrackedItem]);

  return <>{children}</>;
};
